// Form Builder

<template>
	<div class="bld-form-main">

		<div class="title wi8_font">Popup Form Builder</div>

		<div class="box-label">Name</div>
		<div id="inp-name" @click="popupInput" v-html="convertLFs(rec.name)"></div>
		
		<div class="v-spacer"></div>

		<div class="box-label">City</div>
		<div id="inp-city" @click="popupInput" v-html="convertLFs(rec.city)"></div>

		<div class="v-spacer"></div>

		<div class="box-label">My Story</div>
		<div id="inp-story" @click="popupInput" v-html="convertLFs(rec.story)"></div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { eventBus } from '@/main';

export default {
	data() {
		return {
			rec: {
				name: "Steve!",
				city: "Chicago!",
				story: "This could be a long long story",
			},
			popElements: {
				"inp-name": {
					colName: "name",
					popType: "input",
					label: "Enter Name",
					// multiLine: true,
					width: 260,
					maxLen: 100,
				},
				"inp-city": {
					colName: "city",
					popType: "input",
					label: "Enter City",
					// multiLine: true,
					width: 260,
					maxLen: 100,
				},
				"inp-story": {
					colName: "story",
					popType: "input",
					label: "Enter Story",
					multiLine: true,
					maxLen: 300,
				},
			},
		}
	},
	methods: {
		popupInput(evt) {
			m("popup input", evt.target.id);
			let eleId = evt.target.id;
			let val = document.getElementById(eleId).innerText;
			let colName = this.popElements[eleId].colName;

			let payload = {
				eleId: eleId,
				colName: colName,
				popType: this.popElements[eleId].popType,
				popTitle: this.popElements[eleId].label,
				defaultVal: this.rec[colName],
				maxLen: this.popElements[eleId].maxLen || 50,
				width: this.popElements[eleId].width || 120,
				multiLine: (this.popElements[eleId].multiLine===true),
			};
			m("payload", payload);
			eventBus.$emit("popup", payload);			
		},
		handleUpdateVal(payload) {
			m("form caught handle update", payload);
			let el = document.getElementById(payload.eleId);
			let val = payload.val;
			el.innerText = val;

			m("new val", val.length, val);

			this.rec[payload.colName] = val;			
			m("rec is now", this.rec);

		},
		convertLFs(str1="") {
			m("convert LFs", str1);
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
	},
	
	created() {
		m("build created");
		eventBus.$on('update-value', this.handleUpdateVal);
	},
	beforeDestroy() {
		eventBus.$off('update-value', this.handleUpdateVal);
	},
	
}
</script>

<style scoped>
.bld-form-main {
	height: 100%;
	background-color: #EEFCEE;
	padding: 5px;
	border: solid 0px #009;
}

.title {
	color: #090;
}

.box-label {
	display: inline-block;
	width: 80px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #369;
}

#inp-name {
	display: inline-block;
	width: 250px;
	overflow: hidden;
	height: 25px;
	overflow-x: none;
	overflow-y: auto;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

#inp-city {
	display: inline-block;
	width: 250px;
	overflow: hidden;
	height: 25px;
	overflow-x: none;
	overflow-y: auto;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

#inp-story {
	display: inline-block;
	width: 250px;
	height: 120px;
	overflow-x: none;
	overflow-y: auto;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #69C;
}

</style>
